import React from 'react'
import { Select } from 'antd'
import { getRootDom } from '@/utils/utils'

export default ({ options, renderTop, ...restProps }) => {
    return (
        <Select
            mode="multiple"
            maxTagCount="responsive"
            autoClearSearchValue={false}
            dropdownMatchSelectWidth={250}
            getPopupContainer={getRootDom}
            showSearch
            showArrow
            allowClear
            filterOption={(input, option) =>
                option?.props?.children?.toLowerCase?.()?.indexOf?.(input?.toLowerCase?.()) >= 0
            }
            {...restProps}
        >
            {typeof renderTop === 'function' ? renderTop(Select.Option) : null}
            {options.map(item => (
                <Select.Option key={item}>{item}</Select.Option>
            ))}
        </Select>
    )
}
